module.exports = __webpack_public_path__ + "static/img/error-outline-blue.9f4374c4.svg";